import { firestore } from './firebase';
//import firestore from './firebase';

const initState = chatStore => {
    console.log('initState... firestore', firestore);
    firestore
      .collection('messages')
      .onSnapshot( (snapshot) => {
          snapshot.docChanges().forEach( (docChange) => {
              console.log('docChanges', docChange.doc.data());
              switch (docChange.type) {
                  case 'added':
                    chatStore.addMessage(docChange.doc.id, docChange.doc.data());
                    break;
                  default:
                    console.error('Can not remove or modify messages yet!');
                    break;
              }
          })
      })
};

export default initState;


// WEBPACK FOOTER //
// ./state/initState.js